export default __webpack_public_path__ + "cc878e451ca7dfc3462f77873925d61d.webp";